__turbopack_context__.v({
  "checkIcon": "selectBox-module-scss-module__063kza__checkIcon",
  "dark": "selectBox-module-scss-module__063kza__dark",
  "default": "selectBox-module-scss-module__063kza__default",
  "disabled": "selectBox-module-scss-module__063kza__disabled",
  "drawerWrapper": "selectBox-module-scss-module__063kza__drawerWrapper",
  "icon": "selectBox-module-scss-module__063kza__icon",
  "inner": "selectBox-module-scss-module__063kza__inner",
  "isFull": "selectBox-module-scss-module__063kza__isFull",
  "isOpen": "selectBox-module-scss-module__063kza__isOpen",
  "item": "selectBox-module-scss-module__063kza__item",
  "large": "selectBox-module-scss-module__063kza__large",
  "line": "selectBox-module-scss-module__063kza__line",
  "list": "selectBox-module-scss-module__063kza__list",
  "medium": "selectBox-module-scss-module__063kza__medium",
  "none": "selectBox-module-scss-module__063kza__none",
  "select": "selectBox-module-scss-module__063kza__select",
  "selected": "selectBox-module-scss-module__063kza__selected",
  "small": "selectBox-module-scss-module__063kza__small",
  "withHover": "selectBox-module-scss-module__063kza__withHover",
  "withMaxHeight": "selectBox-module-scss-module__063kza__withMaxHeight",
  "wrapper": "selectBox-module-scss-module__063kza__wrapper",
});
